// Making a new JS component
// 1 - Replace magazine with new name ( 8 occurences in this file )
// 2 - All code goes into init()
// 3 - Save file as new name .js
var magazine = {
	name: 'magazine',
	componentInitSelector: '.article-content',
	registerComponent: function() {
		
		if ( $(magazine.componentInitSelector).length ) {
			framework.registerComponent(magazine);
		}
	},
	
	init: function() {
		// All code for this component goes in here
		log(config.application.name + " •• magazine in " + Math.round( performance.now() - framework.initComponents.componentInitTime) + " milliseconds" );

		let articleContent = document.querySelector('.article-content');
		let h2s = articleContent.querySelectorAll('h2');
		let contentsTable = document.querySelector('.contents-table');
		


		if(contentsTable && h2s.length) {

			let contentsTablelist = contentsTable.querySelector('ul');
			contentsTable.classList.add('in');

			h2s.forEach( h2 => {
				let li = document.createElement('li');
				let a = document.createElement('a');
				let text = h2.textContent;
				let id = "id" + Math.random().toString(16).slice(2)
				
				console.log(id)
				// let id = h2.id;
				let href = '#' + id;

				h2.id = id;

				a.textContent = text;
				a.href = href;

				li.appendChild(a);
				contentsTablelist.appendChild(li);

				a.addEventListener('click', function(e) {
					e.preventDefault();
					let target = document.querySelector(href);
					let targetTop = target.getBoundingClientRect().top;
					let scrollY = window.scrollY;
					let scrollTarget = scrollY + targetTop - 100;

					window.scrollTo({
						top: scrollTarget,
						behavior: 'smooth'
					});
				});
			});
		}
	}
}

// Register self to the framework
magazine.registerComponent();